<template>
  <div class="contents">
    <h2>マイタスク</h2>

    <div class="container">
      <template v-if="isLoading">
        <loading :isLoading="isLoading" :message="'データ読み込み中...'"></loading>
      </template>

      <template v-else>
        <section>
          <div class="baseinfo">
          </div><!-- /baseinfo -->

          <div class="maininfo">

            <div class="tabs">
              <scroll-tabs style="width: 100%">
                <ul>
                  <template v-if="authStore.hasPermission(PermissionConst.DAKOKU_IKKATSU_SYOUNIN)">
                    <li :class="{ active: tab === 'dakoku-syounin', error: isErrorDakoku }"><a
                        @click="changeTab('dakoku-syounin')">打刻承認</a>
                    </li>
                    <li :class="{ active: tab === 'kintai-check-staff-list', error: isErrorDakoku }"><a
                        @click="changeTab('kintai-check-staff-list')">勤怠確認</a></li>
                  </template>

                  <template v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)">
                    <li :class="{ active: tab === 'soumu-dakoku-check', error: isErrorDakoku }"><a
                        @click="changeTab('soumu-dakoku-check')">総務確認</a></li>
                  </template>

                  <li :class="{ active: tab === 'shinsei-list' }">
                    <a @click="changeTab('shinsei-list')">申請一覧</a>
                  </li>

                  <li :class="{ active: tab === 'over-45-zangyou-list', error: isErrorDakoku }"
                    v-if="authStore.hasPermission(PermissionConst.ZANGYOU_CHECK)">
                    <a @click="changeTab('over-45-zangyou-list')">残業確認</a>
                  </li>

                  <template v-if="authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)">
                    <li class="time-sheet-kakutei-shime" :class="{ active: tab === 'time-sheet-kakutei-shime', error: isErrorDakoku }">
                      <a @click="changeTab('time-sheet-kakutei-shime')">タイムシート確定締</a>
                    </li>
                  </template>

                  <template v-if="authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)
        && authStore.hasPermission(PermissionConst.CAN_ACCESS_HAKEN_SYAIN)
        ">
                    <li :class="{ active: tab === 'hakensaki-shime-check-list', error: isErrorDakoku }"><a
                        @click="changeTab('hakensaki-shime-check-list')">派遣先締確認</a></li>
                  </template>

                </ul>
              </scroll-tabs>
            </div><!-- /tabs -->

            <div class="tab-container">
              <component :is="currentTab" :form="form" :options="options" :tab="tab" />
            </div>

          </div><!-- /maininfo -->
        </section>

      </template>
    </div>

  </div>
</template>

<script lang="ts">

import { defineComponent, onMounted } from 'vue'
import { useInit } from '@/composable/mytask/init';
import { useTab } from '@/composable/common/tab';
import { useTabError } from '@/composable/mytask/taberror';
import DakokuSyounin from './parts/DakokuSyounin.vue';
import KintaiCheckStaffList from './parts/KintaiCheckStaffList.vue';
import SoumuDakokuCheck from './parts/SoumuDakokuCheck.vue';
import TimeSheetKakuteiShime from './parts/TimeSheetKakuteiShime.vue';
import Over45ZangyouList from './parts/Over45ZangyouList.vue';
import ShinseiList from '@/components/shinsei/list/Search.vue';
import HakensakiShimeCheckList from './parts/HakensakiShimeCheckList.vue';
import { useAuthStore } from '@/store/auth';
import { PermissionConst } from '@/const/Permission';
import { useShinseiStore } from '@/store/shinsei';
import ShinseiOptionConst from "@/const/Shinsei/Option";
import OptionConst from '@/const/Option';
import { useMyTaskCommonStore } from '@/store/mytask-common';

export default defineComponent({
  setup() {

    const { isLoading, isError, form, options } = useInit()

    const { tab, currentTab } = useTab('dakoku-syounin')

    // タブ内のエラーチェック
    const { isErrorDakoku } = useTabError(form)

    const authStore = useAuthStore()
    const shinseiStore = useShinseiStore()

    const myTaskCommonStore = useMyTaskCommonStore()
    onMounted(async () => {
      if (myTaskCommonStore.tabName) {
        // タブ名がstoreに保存されている場合はそれを開く
        tab.value = myTaskCommonStore.tabName;
      } else if (authStore.hasPermission(PermissionConst.SOUMU_DAKOKU_KAKUNIN)) {
        // タブ名指定がない場合の権限ごとのデフォルトタブ
        tab.value = 'soumu-dakoku-check';
      } else if (authStore.hasPermission(PermissionConst.KINTAI_MANAGE_FOR_HAKENSAKI)) {
        // タブ名指定がない場合の権限ごとのデフォルトタブ
        tab.value = 'time-sheet-kakutei-shime';
      } else if (authStore.hasPermission(PermissionConst.ZANGYOU_CHECK)) {
        // タブ名指定がない場合の権限ごとのデフォルトタブ
        tab.value = 'over-45-zangyou-list';
      } else if (authStore.hasPermission(PermissionConst.DAKOKU_IKKATSU_SYOUNIN)) {
        // タブ名指定がない場合の権限ごとのデフォルトタブ
        tab.value = "dakoku-syounin";
      }

      shinseiStore.setItem({
        syuugyouBasyoId: null,
        shinseiStatus: OptionConst.SYOUNIN_STATUS.WAIT,
        searchStatus: ShinseiOptionConst.SEARCH_STATUS.NEED_SYOUNIN,
        shinseiType: OptionConst.SHINSEI_CODE.JIKANGAI,
        name: null,
        staffCode: null,
        shinseiTargetDate: null,
        shinseiTargetMonth: null
      })
    });

    const changeTab = async (tabName: string) => {
      await myTaskCommonStore.setTargetId(null)     // タブを切り替えた場合、スクロールに使用する対象IDをクリアする
      await myTaskCommonStore.setTab(tabName) // 戻ってきたとき用にタブ切替のたびにタブ名を保存する
      tab.value = tabName
    }

    return {
      form,
      options,
      isLoading,
      isError,
      tab,
      currentTab,
      isErrorDakoku,
      authStore,
      PermissionConst,
      changeTab
    }
  },
  components: {
    'parts-dakoku-syounin': DakokuSyounin,
    'parts-kintai-check-staff-list': KintaiCheckStaffList,
    'parts-soumu-dakoku-check': SoumuDakokuCheck,
    'parts-time-sheet-kakutei-shime': TimeSheetKakuteiShime,
    'parts-over-45-zangyou-list': Over45ZangyouList,
    'parts-shinsei-list': ShinseiList,
    'parts-hakensaki-shime-check-list': HakensakiShimeCheckList,
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/mytask-list.scss';
</style>
